import Vue from "vue";
import focuslock from "../components/Lock.vue";
export default {
    getInstance() {
        return new Vue({
            name: "login",
            el: "#loginModal",
            data() {
                return {
                    mode: "login",
                    ready: false
                };
            },
            components:{focuslock},
            methods: {
                open() {
                    this.$modal.show("login-modal");
                },
                opened() {
                    document.getElementById("RedirectUrl").value = window.location.href;
                }
            },
            mounted() {
                this.ready = true;
                if (this.$el.attributes.hasOwnProperty('init') && this.$el.attributes.init.value === 'open') {
                    this.open();
                }
            }
        });
    }
};



// WEBPACK FOOTER //
// ./src/mixed-components/Login.js